var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "products-list" } }, [
    _vm.searching ? _c("div", { attrs: { id: "overlay" } }) : _vm._e(),
    _vm._v(" "),
    _vm.searching
      ? _c("div", { attrs: { id: "searching", role: "alert" } }, [
          _c("span", { staticClass: "fas fa-spinner fa-spin fa-5x" })
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row row-eq-height equal" },
      [
        _vm.products.length === 0
          ? _c(
              "div",
              { staticClass: "col-sm-12", attrs: { id: "no-products" } },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.translations.noproducts) +
                    "\n      "
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.products, function(product, index) {
          return _c(
            "div",
            {
              key: product.ID,
              class: [
                { "first-product": index === 0 },
                "col-xs-12 col-sm-6 col-md-4 col-lg-3"
              ]
            },
            [
              _c("product", {
                attrs: {
                  "image-alt": product.ImageAlt,
                  "image-url": product.ImageUrl,
                  id: product.ID,
                  name: product.Name,
                  url: product.Url,
                  campaigns: _vm.campaigns,
                  ih: product.IsIH,
                  isMedical: product.IsMedicalInstrument,
                  isSupplement: product.IsSupplement,
                  "new-product": product.IsNewProduct,
                  translations: _vm.translations
                }
              })
            ],
            1
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }